'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _ButtonConstants = require('../button/ButtonConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CARET_CLASS_FOR_USE = {
  form: 'private-dropdown__caret--form',
  'form-on-dark': 'private-dropdown__caret--form',
  'link-on-dark': 'private-dropdown__caret--link-on-dark'
};

var UIDropdownCaret = function UIDropdownCaret(_ref) {
  var hidden = _ref.hidden,
      use = _ref.use;

  var computedClassName = (0, _reactUtils.classNames)('uiDropdown__buttonCaret', 'private-dropdown__caret', CARET_CLASS_FOR_USE[use], {
    'private-dropdown__caret--hidden': hidden
  });
  return _react2.default.createElement(
    'span',
    { className: computedClassName },
    _react2.default.createElement('span', { className: 'caret' })
  );
};

UIDropdownCaret.propTypes = {
  hidden: _react.PropTypes.bool,
  use: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES))
};

exports.default = UIDropdownCaret;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/dropdown/UIDropdownCaret.js
// module id = 307
// module chunks = 0